import { render, staticRenderFns } from "./TopFaq.vue?vue&type=template&id=393c6d99&scoped=true"
import script from "./TopFaq.vue?vue&type=script&lang=js"
export * from "./TopFaq.vue?vue&type=script&lang=js"
import style0 from "./TopFaq.vue?vue&type=style&index=0&id=393c6d99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c6d99",
  null
  
)

export default component.exports